import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import Sortable from 'sortablejs';
import { FormGroup } from '@angular/forms';
import { FormlyField, FormlyFieldConfig } from '@ngx-formly/core';
import { cloneDeep, find, findIndex } from 'lodash';
import {
  decodeBase64FromDataURL,
  getRandomUID,
  saveAsJSONFile,
} from '../../../utils';
import {
  basicCommonForm,
  // basicInputForm,
  checkboxInputForm,
  optionsInputForm,
  placeholderInputForm,
  toggleInputForm,
} from './edit-forms';
import {
  FormExportButton,
  FormExportButtonSeverity,
  FormExportButtonType,
  FormExportConfig,
} from '../../types';
import { fileInputForm } from './edit-forms/file-input.form';
import { expressionsInputForm } from './edit-forms/expressions-input-form';
import { ExpressionContainer } from '../../../../../../backend-core-lib/cross-lib';
import { evaluateFormlyExpression, transformRawToFormly } from '../../utils';
import {
  ConfigService,
  getTranslatedMenuItem,
  getTranslatedMenuItems,
} from '../../../config';
import { homeBreadcrumbsConfig } from '../../../../app/navigation/config';
import { appsOverviewBreadcrumbsConfig } from '../../../../app/routes/apps/config';
import { formGeneratorBreadcrumbsConfig } from './config/breadcrumbs.config';
import { MenuItem } from 'primeng/api';

interface UICommonElement {
  id: string;
  icon: string;
  label: string;
}
interface UiAllElements {
  inputs: UICommonElement[];
  containers: UICommonElement[];
}
@Component({
  selector: 'form-generator',
  templateUrl: './form-generator.component.html',
  styleUrl: './form-generator.component.scss',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
})
export class FormGeneratorComponent implements OnChanges, OnInit, OnDestroy {
  @HostBinding('class')
  readonly cssClass = 'form-generator  page-container flex-1 flex';

  uiCommonClasses =
    ' dark:bg-surface-900 justify-between items-center flex cursor-grab p-inputtext relative  hover:bg-primary-200 text-primary-500 p-3 mb-1 border br rounded-md select-none  ';
  uiElementClasses = ' ui-element--input min-w-32 ' + this.uiCommonClasses;
  uiContainerClasses =
    ' ui-element--container min-w-40 ' + this.uiCommonClasses;

  selectedMode = '';
  selectedItemMode = '';
  modeOptions: string[] = [];
  modeItemOptions: string[] = [];

  designMode = '';
  uiItemsMode = '';

  selectedUidElement = '';

  // initialNavCollapsed = false;
  // refreshingSelectedUIElement = false;

  @Input()
  hideNavigation = false;

  @Input()
  isModal = false;

  @Input()
  noInputs = true;

  @Input()
  defaultTranslate = false;

  refreshingUi = false;

  form = new FormGroup({});
  formUiSelected = new FormGroup({});

  @Input()
  model = {
    /*address: {
      myFile:
        'filename:R3J1bmRyaXNzICg3KS5wbmc=;data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII=',
    },*/
  };
  modelUiSelected = {
    type: 'input',
  };

  formlyInfosById: Record<string, FormlyFieldConfig> = {};
  fieldsUiSelected = [
    // ...basicInputForm,
    ...optionsInputForm,
    ...toggleInputForm,
  ];
  buttonsUiSelected: FormExportButton[] = [
    {
      actionId: 'delete',
      icon: 'pi pi-trash',
      type: 'button',
      label: 'formGenerator.buttons.removeElement',
      translate: true,
      severity: 'danger',
    },
    {
      actionId: 'submit',
      icon: 'pi pi-save',
      type: 'submit',
      label: 'formGenerator.buttons.saveChanges',
      translate: true,
      severity: 'primary',
    },
  ];

  @Input()
  fieldsRaw: FormlyFieldConfig[] = [
    {
      id: 'root-wrapper-' + getRandomUID(false, true),
      wrappers: ['root'],
      fieldGroup: [],
    },
  ];
  fieldsFormly: FormlyFieldConfig[] = [
    {
      id: 'root-wrapper-' + getRandomUID(false, true),
      wrappers: ['root'],
      fieldGroup: [],
    },
  ];
  buttonsFormly: FormExportButton[] = [
    {
      actionId: 'submit',
      // icon?: string;
      type: 'submit',
      label: 'Submit',
      translate: false,
      severity: 'primary',
    },
  ];

  uiAll: UiAllElements = {
    inputs: [
      {
        id: 'input_input',
        icon: 'pi pi-pen-to-square',
        label: 'formGenerator.element.input.label',
      },
      {
        id: 'input_password',
        icon: 'pi pi-key',
        label: 'formGenerator.element.password.label',
      },
      {
        id: 'input_date',
        icon: 'pi pi-calendar',
        label: 'formGenerator.element.date.label',
      },
      {
        id: 'input_file',
        icon: 'pi pi-file',
        label: 'formGenerator.element.file.label',
      },
      {
        id: 'input_radio',
        icon: 'pi pi-circle',
        label: 'formGenerator.element.radio.label',
      },
      {
        id: 'input_select',
        icon: 'pi pi-list',
        label: 'formGenerator.element.select.label',
      },
      {
        id: 'input_toggle',
        icon: 'pi pi-check',
        label: 'formGenerator.element.toggle.label',
      },
      {
        id: 'input_textarea',
        icon: 'pi pi-align-left',
        label: 'formGenerator.element.textarea.label',
      },
      {
        id: 'input_checkbox',
        icon: 'pi pi-check-square',
        label: 'formGenerator.element.checkbox.label',
      },
    ],
    containers: [
      {
        id: 'wrapper_row',
        icon: 'pi pi-arrows-h',
        label: 'formGenerator.element.row.label',
      },
      {
        id: 'wrapper_fieldset',
        icon: 'pi pi-table',
        label: 'formGenerator.element.fieldset.label',
      },
      {
        id: 'array_fields-array',
        icon: 'pi pi-ellipsis-v',
        label: 'formGenerator.element.fieldsArray.label',
      },
    ],
  };
  uiAllBySubId: Record<string, UICommonElement> = {};

  breadcrumbsItems: MenuItem[] = [];
  breadcrumbsHome!: MenuItem;

  constructor(
    public translateService: TranslateService,
    public configService: ConfigService,
    private ref: ChangeDetectorRef,
  ) {
    this.initUiAllBySubId();
    this.createNewFormlyItem = this.createNewFormlyItem.bind(this);
    this.moveFormlyItem = this.moveFormlyItem.bind(this);
    this.selectUidElement = this.selectUidElement.bind(this);
    this.setTimeoutAndRefresh = this.setTimeoutAndRefresh.bind(this);

    this.modeOptions = [
      this.translateService.instant('formGenerator.mode.design'),
      this.translateService.instant('formGenerator.mode.preview'),
    ];
    this.modeItemOptions = [
      this.translateService.instant('formGenerator.itemMode.uiElement'),
      this.translateService.instant('formGenerator.itemMode.selected'),
    ];
    this.selectedMode = this.modeOptions[0];
    this.designMode = this.modeOptions[0];

    this.selectedItemMode = this.modeItemOptions[0];
    this.uiItemsMode = this.modeItemOptions[0];
  }

  initBreadcrumbs(): void {
    this.breadcrumbsItems = getTranslatedMenuItems(
      formGeneratorBreadcrumbsConfig,
      this.translateService,
    );
    //console.log(this.breadcrumbsItems);
    this.breadcrumbsHome = getTranslatedMenuItem(
      homeBreadcrumbsConfig,
      this.translateService,
    );
  }
  ngOnChanges(changes: SimpleChanges) {
    // console.log('ngOnChanges');
    this.setTimeoutAndRefresh();
    this.refreshView();
  }
  ngOnInit() {
    //c onsole.log('ngOnInit');
    this.initBreadcrumbs();
    /*this.initialNavCollapsed = this.configService.getIsNavCollapsed();
    if (!this.initialNavCollapsed) {
      this.configService.setNavCollapsed(true);
    }*/
    if (this.noInputs) {
      this.refreshView();
    }
  }

  initUiAllBySubId(): void {
    this.uiAllBySubId = {};
    this.uiAll.containers.forEach((element) => {
      this.uiAllBySubId[element.id.split('_')[1]] = element;
    });
    this.uiAll.inputs.forEach((element) => {
      this.uiAllBySubId[element.id.split('_')[1]] = element;
    });
  }

  ngOnDestroy() {
    console.log('ngOnDestroy');
    /*if (!this.initialNavCollapsed && this.configService.getIsNavCollapsed()) {
      this.configService.setNavCollapsed(false);
    }*/
  }

  onSelectImportFormFile($event: any): void {
    const self = this;
    if ($event.currentFiles?.length) {
      const file = $event.currentFiles[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onloadend = function () {
        // console.log(reader.result);

        const extendedDataUrl = `filename:${btoa(file.name)};${reader.result}`;
        /*console.log(extendedDataUrl);
        console.log(decodeBase64FromDataURL(extendedDataUrl));*/
        self.importFormFile(
          JSON.parse(
            decodeBase64FromDataURL(extendedDataUrl),
          ) as FormExportConfig,
        );
      };
      reader.onerror = function (error) {};
    }
  }
  importFormFile(exportConfig: FormExportConfig): void {
    // console.log(exportConfig);
    this.fieldsRaw = exportConfig.fields;
    this.selectedUidElement = '';
    this.selectedItemMode = this.uiItemsMode;
    this.setTimeoutAndRefresh();
  }
  onExportFormFile(): void {
    const exportConfig: FormExportConfig = {
      fields: this.fieldsRaw,
    };
    saveAsJSONFile('form_export.json', exportConfig);
  }

  changeSelect() {
    console.log(this.model);
    this.refreshView();
  }

  changeItemSelect() {
    this.refreshView();
  }

  updateFormlySelected(): void {
    if (this.selectedUidElement) {
      // this.refreshingSelectedUIElement = true;
      const selectedUiElementInfo =
        this.formlyInfosById[this.selectedUidElement];
      let newFieldsUiSelected: FormlyFieldConfig[] = [];
      if (selectedUiElementInfo) {
        const type = selectedUiElementInfo.type;

        switch (type) {
          case 'password':
          case 'input':
          case 'textarea':
          case 'date':
            newFieldsUiSelected = [
              ...basicCommonForm,
              // ...basicInputForm,
              ...placeholderInputForm,
              ...expressionsInputForm,
            ];
            break;
          case 'file':
            newFieldsUiSelected = [
              ...basicCommonForm,
              // ...basicInputForm,
              ...fileInputForm,
              ...expressionsInputForm,
            ];
            break;
          case 'select':
            newFieldsUiSelected = [
              ...basicCommonForm,
              ...placeholderInputForm,
              // ...basicInputForm,
              ...optionsInputForm,
              ...expressionsInputForm,
            ];
            break;
          case 'radio':
            newFieldsUiSelected = [
              ...basicCommonForm,
              // ...basicInputForm,
              ...optionsInputForm,
              ...expressionsInputForm,
            ];
            break;
          case 'checkbox':
            newFieldsUiSelected = [
              ...basicCommonForm,
              ...checkboxInputForm,
              ...expressionsInputForm,
            ];
            break;
          case 'toggle':
            newFieldsUiSelected = [
              ...basicCommonForm,
              ...toggleInputForm,
              ...expressionsInputForm,
            ];
            break;
          default:
            newFieldsUiSelected = [...basicCommonForm];
            break;
          /*
                    { name: 'input', component: FormInputFieldType },
        { name: 'password', component: FormPasswordFieldType },
        { name: 'select', component: FormSelectFieldType },
        { name: 'date', component: FormDateFieldType },
        { name: 'radio', component: FormRadioFieldType },
        { name: 'file', component: FormFileFieldType },
        { name: 'toggle', component: FormToggleFieldType },

        { name: 'fields-array', component: FormFieldsArrayType },
      ],
      wrappers: [
        { name: 'fieldset', component: FormFieldsetWrapperType },
        { name: 'category', component: FormCategoryWrapperType },
        { name: 'root', component: FormRootWrapperType },
        { name: 'row', component: FormRowWrapperType },
             */
        }
      }
      this.fieldsUiSelected = transformRawToFormly(newFieldsUiSelected);
      // setTimeout(() => (this.refreshingSelectedUIElement = false), 10);
    }
    /*this.fieldsUiSelected = [
      ...basicInputForm,
      ...optionsInputForm,
      ...toggleInputForm,
    ];*/
  }
  updateFormlyInfosById(): void {
    this.formlyInfosById = {};
    (this.fieldsRaw || []).forEach((field) => {
      this.updateFormlyEntryInfo(field);
    });
  }
  updateFormlyEntryInfo(fieldConfig: FormlyFieldConfig): void {
    this.formlyInfosById[fieldConfig.id || ''] = fieldConfig;
    if (fieldConfig.fieldGroup) {
      (fieldConfig.fieldGroup || []).forEach((field) => {
        this.updateFormlyEntryInfo(field);
      });
    }

    if (fieldConfig?.fieldArray) {
      const fieldGroup = (fieldConfig.fieldArray as FormlyFieldConfig)
        .fieldGroup as FormlyFieldConfig[];
      (fieldGroup || []).forEach((field) => {
        this.updateFormlyEntryInfo(field);
      });
    }
  }

  isEmptyForm(): boolean {
    return !this.fieldsRaw[0]?.fieldGroup?.length;
  }
  refreshView(): void {
    const self = this;

    this.updateFormlyInfosById();
    if (this.selectedMode === this.designMode) {
      setTimeout(
        () => {
          //var el = document.getElementById('items') as HTMLElement;
          //var sortable = Sortable.create(el, { animation: 150 });

          if (this.selectedItemMode === this.uiItemsMode) {
            var uiElementsDraggable = [].slice.call(
              document.querySelectorAll('.ui-elements--draggable'),
            );
            for (var i = 0; i < uiElementsDraggable.length; i++) {
              new Sortable(uiElementsDraggable[i], {
                group: {
                  name: 'nested',
                  pull: 'clone',
                  put: false, // Do not allow items to be put into this list
                },
                sort: false,
                animation: 150,
                fallbackOnBody: true,
                swapThreshold: 0.65,

                // Element is chosen
                onChoose: function (/**Event*/ evt) {
                  evt.oldIndex; // element index within parent
                },

                // Element dragging ended
                onEnd: function (/**Event*/ evt) {
                  var itemEl = evt.item; // dragged HTMLElement
                  const itemId = evt.item.getAttribute('item-id');
                  evt.to; // target list
                  // console.log('to', evt.to.id);
                  evt.from; // previous list
                  // console.log('from', evt.from.id);
                  evt.oldIndex; // element's old index within old parent
                  evt.newIndex; // element's new index within new parent
                  evt.oldDraggableIndex; // element's old index within old parent, only counting draggable elements
                  evt.newDraggableIndex; // element's new index within new parent, only counting draggable elements
                  evt.clone; // the clone element
                  evt.pullMode; // when item is in another sortable: `"clone"` if cloning, `true` if moving

                  const targetInfo = self.formlyInfosById[evt.to.id];
                  // console.log(targetInfo);
                  if (!targetInfo) {
                    return;
                  }

                  self.createNewFormlyItem(
                    itemId as string,
                    targetInfo,
                    evt.newIndex ? evt.newIndex - 1 : 0,
                  );
                  self.setTimeoutAndRefresh();

                  /*self.ref.detectChanges();
                self.ref.markForCheck();*/
                },
              });
            }
          }

          /*new Sortable(document.getElementById('items') as HTMLElement, {
          group: 'shared',
          animation: 150,
        });*/

          /*const nestedSortables = document.getElementsByClassName(
          'list-group-item',
        ) as unknown as HTMLElement[];
        for (var i = 0; i < nestedSortables.length; i++) {
          new Sortable(nestedSortables[i], {
            group: 'nested',
            animation: 150,
            fallbackOnBody: true,
            swapThreshold: 0.65,
          });
        }*/
          var nestedSortables = [].slice.call(
            document.querySelectorAll('.nested-sortable'),
          );

          // Loop through each nested sortable element
          for (var i = 0; i < nestedSortables.length; i++) {
            new Sortable(nestedSortables[i], {
              group: 'nested',
              animation: 150,
              fallbackOnBody: true,
              swapThreshold: 0.65,

              // Element is chosen
              onChoose: function (/**Event*/ evt) {
                evt.oldIndex; // element index within parent
                const elemId = evt.item.id;
                if (elemId && self.formlyInfosById[elemId]) {
                  self.selectUidElement(elemId);
                  setTimeout(() => {
                    self.selectUidElement(elemId);
                  }, 1);
                }
              },

              // Element dragging ended
              onEnd: function (/**Event*/ evt) {
                var itemEl = evt.item; // dragged HTMLElement
                const itemId = evt.item.id;
                evt.to; // target list
                // console.log('to', evt.to.id);
                evt.from; // previous list
                // console.log('from', evt.from.id);
                evt.oldIndex; // element's old index within old parent
                evt.newIndex; // element's new index within new parent
                evt.oldDraggableIndex; // element's old index within old parent, only counting draggable elements
                evt.newDraggableIndex; // element's new index within new parent, only counting draggable elements
                evt.clone; // the clone element
                evt.pullMode; // when item is in another sortable: `"clone"` if cloning, `true` if moving

                const targetInfo = self.formlyInfosById[evt.to.id];

                if (!targetInfo) {
                  return;
                }

                const sourceInfo = self.formlyInfosById[evt.from.id];

                if (!sourceInfo) {
                  return;
                }

                self.moveFormlyItem(
                  itemId as string,
                  sourceInfo,
                  targetInfo,
                  evt.newIndex ? evt.newIndex - 1 : 0,
                );
                self.setTimeoutAndRefresh();
              },
            });
          }
        },
        this.isModal ? 1 : 1,
      );
    }
  }

  setTimeoutAndRefresh(): void {
    this.refreshingUi = true;
    this.ref.detectChanges();
    this.ref.markForCheck();
    setTimeout(
      () => {
        // this.fieldsRaw = cloneDeep(this.fieldsRaw);
        this.fieldsFormly = transformRawToFormly(this.fieldsRaw);
        this.refreshView();
        this.refreshingUi = false;
        this.ref.detectChanges();
        this.ref.markForCheck();
      },
      this.isModal ? 1 : 1,
    );
  }
  selectUidElement(elemId: string): void {
    this.ref.detectChanges();
    this.ref.markForCheck();
    this.selectedUidElement = elemId;
    this.modelUiSelected = cloneDeep(this.formlyInfosById[elemId]) as any;
    this.selectedItemMode = this.modeItemOptions[1];
    this.updateFormlySelected();
  }

  removeUiSelected(): void {
    // Search through all the fields for the parent containing the id
    const found = this.getParentFieldConfigOfFieldId(this.selectedUidElement);

    if (found) {
      let indexRemoveItem = findIndex(found?.fieldGroup || [], (field) => {
        return field.id === this.selectedUidElement;
      });
      if (indexRemoveItem >= 0) {
        this.selectedUidElement = '';
        (found?.fieldGroup || []).splice(indexRemoveItem, 1);
        this.setTimeoutAndRefresh();
      } else if (
        found?.fieldArray &&
        (found?.fieldArray as FormlyFieldConfig)?.fieldGroup
      ) {
        const fieldGroups = (found?.fieldArray as FormlyFieldConfig)
          .fieldGroup as FormlyFieldConfig[];
        indexRemoveItem = findIndex(fieldGroups || [], (field) => {
          return field.id === this.selectedUidElement;
        });
        if (indexRemoveItem >= 0) {
          this.selectedUidElement = '';
          (fieldGroups || []).splice(indexRemoveItem, 1);
          this.setTimeoutAndRefresh();
        }
      }
    }
  }
  getParentFieldConfigOfFieldId(id: string): FormlyFieldConfig | undefined {
    let found: FormlyFieldConfig | undefined = undefined;
    if (this.fieldsRaw?.length) {
      for (
        let indexField = 0;
        indexField < this.fieldsRaw.length;
        indexField++
      ) {
        found = this.searchFieldConfigId(id, this.fieldsRaw[indexField]);
        if (found) {
          return found;
        }
      }
    }
    return found;
  }
  searchFieldConfigId(
    id: string,
    field: FormlyFieldConfig,
  ): FormlyFieldConfig | undefined {
    if (field.fieldGroup?.length) {
      for (
        let indexField = 0;
        indexField < field.fieldGroup.length;
        indexField++
      ) {
        if (field.fieldGroup[indexField].id === id) {
          return field;
        }
        const found = this.searchFieldConfigId(
          id,
          field.fieldGroup[indexField],
        );
        if (found) {
          return found;
        }
      }
    }
    if (
      field?.fieldArray &&
      (field?.fieldArray as FormlyFieldConfig)?.fieldGroup
    ) {
      const fieldGroups = (field?.fieldArray as FormlyFieldConfig)
        .fieldGroup as FormlyFieldConfig[];
      const countFields = fieldGroups.length || 0;
      for (let indexField = 0; indexField < countFields; indexField++) {
        const thisCheckingField = fieldGroups[indexField];
        if (fieldGroups[indexField].id === id) {
          return field;
        }
        const found = this.searchFieldConfigId(id, fieldGroups[indexField]);
        if (found) {
          return found;
        }
      }
    }

    return undefined;
  }

  moveFormlyItem(
    itemId: string,
    sourceFieldConfig: FormlyFieldConfig,
    targetFieldConfig: FormlyFieldConfig,
    index: number,
  ): void {
    const indexSourceItem = findIndex(
      sourceFieldConfig?.fieldGroup || [],
      (field) => {
        return field.id === itemId;
      },
    );
    if (
      indexSourceItem >= 0 &&
      sourceFieldConfig?.fieldGroup &&
      targetFieldConfig.fieldGroup
    ) {
      const removed = sourceFieldConfig.fieldGroup.splice(indexSourceItem, 1);
      // targetFieldConfig.fieldGroup.push(removed[0] as FormlyFieldConfig);
      targetFieldConfig.fieldGroup.splice(
        index,
        0,
        removed[0] as FormlyFieldConfig,
      );
    }
  }
  createNewFormlyItem(
    itemId: string,
    targetFieldConfig: FormlyFieldConfig,
    index: number,
  ): void {
    // TODO: get default config by category
    let targetArray = (
      targetFieldConfig?.fieldArray
        ? (targetFieldConfig.fieldArray as FormlyFieldConfig).fieldGroup
        : targetFieldConfig.fieldGroup
    ) as FormlyFieldConfig[];
    /*if (targetFieldConfig.fieldArray) {
    }*/

    /*if (!targetFieldConfig.fieldGroup) {
      targetFieldConfig.fieldGroup = [];
    }*/

    const category = itemId.split('_')[0];
    const type = itemId.split('_')[1];
    /*console.log(
      'FOUND: itemId->',
      itemId,
      '; type->',
      type,
      ',category:',
      category,
    );*/
    const uid = getRandomUID(false, true);
    if (category === 'wrapper') {
      targetArray.splice(index, 0, {
        key: '',
        id: uid,
        className: 'form-wrapper--' + type,
        wrappers: [type],
        props: { translate: this.defaultTranslate },
        fieldGroup: [],
      });
    } else if (category === 'array') {
      targetArray.splice(index, 0, {
        key: '',
        id: uid,
        className: 'form-wrapper--row',
        type: type,
        props: {
          addEntryButtonLabel: '',
          label: '',
        },
        fieldArray: {
          className: 'form-wrapper--row',
          fieldGroup: [],
        },
        /*wrappers: [type],
        props: { translate: this.defaultTranslate },
        fieldGroup: [],*/
      });
    } else {
      targetArray.splice(index, 0, {
        key: '',
        id: uid,
        type: type,
        props: {
          required: false,
          type: 'text',
          translate: this.defaultTranslate,
          placeholder: '',
        },
      });
    }
    /*console.log(this.fieldsRaw);*/
  }

  showFieldErrors(fieldConfig: FormlyFieldConfig): string {
    if (
      fieldConfig.fieldArray &&
      (fieldConfig?.key === undefined || fieldConfig?.key === '')
    ) {
      return 'error';
    }

    return '';
  }
  getWrapperClasses(fieldConfig: FormlyFieldConfig): string {
    /*if (!fieldConfig?.wrappers?.length) {
      return '';
    }*/
    /*console.log(fieldConfig);*/
    let toReturn = `ui-layout-wrapper `;
    if (fieldConfig?.wrappers?.length) {
      toReturn += ` ui-layout-wrapper--${fieldConfig.wrappers[0] as string} `;
    } else {
      // Array
      toReturn += ` ui-layout-wrapper--fieldset`;
    }

    if (this.selectedUidElement === fieldConfig.id) {
      toReturn += ` bg-primary-300 `;
    } else {
      toReturn += ` bg-surface-50 dark:bg-surface-900 `;
    }

    /*if (fieldConfig?.key != undefined && fieldConfig?.key != '') {*/
    toReturn += ` !pt-6 !pl-3 !pr-3`;
    /*}*/

    return toReturn;
  }

  onSubmitUiSelected(model: any) {
    if (this.formUiSelected.valid) {
      const fieldModified = this.formlyInfosById[this.selectedUidElement];
      if (fieldModified) {
        const newPayload: FormlyFieldConfig = cloneDeep(
          model,
        ) as FormlyFieldConfig;

        Object.getOwnPropertyNames(newPayload).forEach((key: string) => {
          // @ts-ignore
          fieldModified[key] = (newPayload as any)[key];
        });
      }
      this.setTimeoutAndRefresh();

      /*this.formlyInfosById[this.selectedUidElement] = cloneDeep(
        this.formUiSelected,
      ) as FormlyFieldConfig;*/
    }
  }

  onFormModelChange(model: any) {
    saveAsJSONFile(
      (this.form.valid ? 'valid' : 'invalid') + '_form_payload.json',
      model,
    );
    // TODO: Filter manually all fields based on _hide, removing values in the payload tha tare hidden
  }
}
